import t from "./chunk920.js";
import i from "./chunk958.js";
function a(r) {
  return t("MuiSnackbar", r);
}
i("MuiSnackbar", ["root", "anchorOriginTopCenter", "anchorOriginBottomCenter", "anchorOriginTopRight", "anchorOriginBottomRight", "anchorOriginTopLeft", "anchorOriginBottomLeft"]);
export {
  a as getSnackbarUtilityClass
};
